import { render, staticRenderFns } from "./coa.vue?vue&type=template&id=06b8ee04&scoped=true"
import script from "./coa.vue?vue&type=script&lang=js"
export * from "./coa.vue?vue&type=script&lang=js"
import style0 from "./coa.vue?vue&type=style&index=0&id=06b8ee04&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b8ee04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06b8ee04')) {
      api.createRecord('06b8ee04', component.options)
    } else {
      api.reload('06b8ee04', component.options)
    }
    module.hot.accept("./coa.vue?vue&type=template&id=06b8ee04&scoped=true", function () {
      api.rerender('06b8ee04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventoryLabResult/coa.vue"
export default component.exports